import * as React from "react";
import { Button } from "@fluentui/react-components";
import {
    CopyRegular,
    CheckmarkRegular
} from "@fluentui/react-icons";
import { copyToClipboard } from "../util/Clipboard";

export interface CopyButtonProps {
    disabled?: boolean;
    value?: string;
    title?: string;
}

export const CopyButton: React.FC<CopyButtonProps> = ({ disabled, value, title }) => {
    const [showCheckmark, setShowCheckmark] = React.useState(false);
    const timeoutRef = React.useRef<NodeJS.Timeout | null>(null);

    const handleClick = async (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();

        if (value) {
            await copyToClipboard(value);
        }

        // Show checkmark and reset timer
        setShowCheckmark(true);

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            setShowCheckmark(false);
        }, 2000);
    };

    // Clean up timeout on unmount
    React.useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    return (
        <Button
            size="small"
            title={title}
            icon={showCheckmark ? <CheckmarkRegular /> : <CopyRegular />}
            disabled={disabled}
            onClick={handleClick}
        />
    );
};
